export enum PaymentMethodEnum {
  PREPAYMENT = 'PREPAYMENT',
  POSTPAYMENT = 'POSTPAYMENT'
};
